module.exports = __webpack_public_path__ + "img/Solutions-EstateAssist.c20f8000.jpg";